import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslationStore {
  private readonly translate = inject(TranslateService);

  readonly currentLang = signal<string>('en');

  init(): void {
    this.translate.setDefaultLang('en');
    const saved = localStorage.getItem('app_lang');
    const lang = saved && ['en', 'ro'].includes(saved) ? saved : 'en';
    this.translate.use(lang);
    this.currentLang.set(lang);
  }

  changeLang(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('app_lang', lang);
    this.currentLang.set(lang);
  }
}
